import React from "react";
import SideMenu, { SideMenuLink, SideMenuSpacer } from "@amzn/meridian/esm/components/side-menu";
import Row from "@amzn/meridian/esm/components/row";
import Box from "@amzn/meridian/esm/components/box";
import { Text, Theme } from "@amzn/meridian";

const SidebarInClient = ({ selectedTab, setSelectedTab }) => {
  return (
    <Theme
      tokens={{
        sideMenuLinkIndicatorColorSelected: "#AFE8D7",
        sideMenuLinkIndicatorColorPressed: "#55AA96",
      }}
    >
      <SideMenu width="176px">
        <SideMenuLink selected={selectedTab === "summaries"} onClick={() => setSelectedTab("summaries")}>
          <Row spacing="none" spacingInset="none">
            <Box width="24px"></Box>
            <Text>Summaries</Text>
          </Row>
        </SideMenuLink>
        <SideMenuLink selected={selectedTab === "help"} onClick={() => setSelectedTab("help")}>
          <Row spacing="none" spacingInset="none">
            <Box width="24px"></Box>
            <Text>Feedback</Text>
          </Row>
        </SideMenuLink>
        {[...Array(13)].map((_, idx) => (
          <SideMenuSpacer key={idx} />
        ))}
      </SideMenu>
    </Theme>
  );
};

export default SidebarInClient;
